import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'

import NotFound from 'errorPages/NotFound'

import ESignPlanDocuments, { SIGN_PLAN_DOCUMENTS_PATH } from './eSign/ESignPlanDocuments'
import LegalDocuments from './viewDocuments/index'

export const LEGAL_DOCUMENTS_PATH = 'legal-documents'

const BenefitDetails: React.FC = () => {
  let match = useRouteMatch()

  return (
    <Switch>
      <Route path={`${match.path}`} exact component={LegalDocuments} />
      <Route path={`${match.path}/${SIGN_PLAN_DOCUMENTS_PATH}/:planPeriod`} exact component={ESignPlanDocuments} />
      <Route>
        <NotFound />
      </Route>
    </Switch>
  )
}

export default BenefitDetails
